import { useState } from 'react';
import './DeleteOfferPermanently.css';
import CloseModal from '../../CommonFunctions/closeModal';
import { useAtom } from 'jotai';
import { useDetailedOffer, useShowPopUpModal, useModalVersion, useModalInfo } from '../../../../data/GlobalStates';
import { getStorage, ref as storageRef, listAll, deleteObject } from 'firebase/storage';
import FloatingLoading from '../FloatingLoading/FloatingLoading';

const DeleteOfferPermanently = ({db, PopUpModalRef, set, setRefresh }) => {

    //Stany globalne:
    const [ DetailedOffer, setDetailedOffer ] = useAtom(useDetailedOffer);
    const [ ShowPopUpModal, setShowPopUpModal] = useAtom(useShowPopUpModal);
    const [ ModalVersion, setModalVersion] = useAtom(useModalVersion);
    const [ ModalInfo, setModalInfo] = useAtom(useModalInfo);

    //Stany lokalne:
     const [ showAnimation, setShowAnimation] = useState(false)


const deleteFolderFromStorage = async (folderPath) => {
  const storage = getStorage();
  const folderRef = storageRef(storage, folderPath);

  try {
    const listResult = await listAll(folderRef);

    console.log("🧾 Pliki do usunięcia:", listResult.items.map(item => item.fullPath));

    const deletePromises = listResult.items.map(itemRef => deleteObject(itemRef));
    await Promise.all(deletePromises);

    console.log(`✅ Folder ${folderPath} usunięty`);
  } catch (error) {
    console.error('❌ Błąd usuwania folderu:', error);
  }
};

const deleteOfferPermanently = async () => { 
  const date = new Date();
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let day = date.getDate(); // <- poprawka tu

  try {
 
    setShowAnimation(!showAnimation)

    await set(PopUpModalRef(db, `offers/${DetailedOffer.id}`), null);

    await deleteFolderFromStorage(`OffersImages/${DetailedOffer.id}`);

    await set(PopUpModalRef(db, `offersDeletedPermanently/${DetailedOffer.companyName}/${DetailedOffer.id}`), {
      addDate: DetailedOffer.addDate,
      id: DetailedOffer.id,
      title: DetailedOffer.title,
      name: DetailedOffer.companyName
    });

    setRefresh(Math.floor(Math.random() * 121));
    setModalVersion(12);
    setModalInfo({ title: 'Ogłoszenie usunięte' });

  } catch (error) {

    setModalVersion(12);
    setModalInfo({ title: 'Ups coś poszło nie tak spróbuj ponownie' });

    await set(PopUpModalRef(db, `errors/${year}/${month}/${day}/deleteOfferPermanently`), error.message);
  } finally {
    setShowAnimation(!showAnimation)
  }
};

    return (
        <div id='EditUserFields'> 
         { showAnimation ? <FloatingLoading/> : ''}
             <h1 className='ModalTitle'>{ModalInfo.title}</h1>
               <h3 className='DeleteOfferModalMessage'>{DetailedOffer.title}</h3>
                 <h4 className='DeleteOfferModalMessageID'>ID Oferty: {DetailedOffer.id}</h4>
              <div id='DeleteConfirmDiv'>
                <button className='ConfirmBtns' onClick={deleteOfferPermanently}>Tak</button>
                <button className='ConfirmBtns' onClick={() => CloseModal(setShowPopUpModal, setModalVersion, setModalInfo)}>Nie</button>
              </div>
        </div>
    )
};

export default DeleteOfferPermanently;
